import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { httpBatchLink } from '@trpc/client';
import { trpc } from './lib/trpc';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { AppShell } from './components/layout/AppShell';
import { SeatsScreen } from './pages/SeatsScreen';
import { DashboardScreen } from './pages/DashboardScreen';
import { SubscriptionsScreen } from './pages/SubscriptionsScreen';
import { CreateSubscriptionScreen } from './pages/CreateSubscriptionScreen';
import { CreateBranchScreen } from './pages/CreateBranchScreen';
import { UsersScreen } from './pages/UsersScreen';
import { UserFormScreen } from './pages/UserFormScreen';
import { UserDetailScreen } from './pages/UserDetailScreen';
import { ChatbotScreen } from './pages/ChatbotScreen';
import { SettingsScreen } from './pages/SettingsScreen';
import { Toaster } from './components/ui/sonner';

export default function App() {
  const [queryClient] = useState(() => new QueryClient());
  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [
        httpBatchLink({
          url: '/api/trpc',
          headers() {
            return {
              'x-tenant-slug': 'demo-library',
            };
          },
        }),
      ],
    }),
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        <AppProvider>
          <Router>
            <Routes>
              <Route element={<AppShell />}>
                <Route path="/" element={<Navigate to="/seats" replace />} />
                <Route path="/seats" element={<SeatsScreen />} />
                <Route path="/dashboard" element={<DashboardScreen />} />
                <Route path="/users" element={<UsersScreen />} />
                <Route path="/subscriptions" element={<SubscriptionsScreen />} />
                <Route path="/chatbot" element={<ChatbotScreen />} />
                <Route path="/settings" element={<SettingsScreen />} />
              </Route>
              <Route path="/subscribe" element={<CreateSubscriptionScreen />} />
              <Route path="/create-branch" element={<CreateBranchScreen />} />
              <Route path="/users/new" element={<UserFormScreen />} />
              <Route path="/users/:id" element={<UserDetailScreen />} />
              <Route path="/users/:id/edit" element={<UserFormScreen />} />
            </Routes>
            <Toaster />
          </Router>
        </AppProvider>
      </QueryClientProvider>
    </trpc.Provider>
  );
}
